import { defaultDateFormatter } from "../../Helper/functionHelper";
import {
  deleteDocument,
  downloadResignationDocument,
} from "../../services/exitManagement";
import TableLayout from "../layout/TableLayout";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../Table";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import useConfirm from "../../hooks/useConfirm";
import useAuthUser from "../../hooks/useAuthUser";

const DocumentsTable = ({
  documentsData,
  heading = "Documents",
  showAddButton,
  onModalOpen,
  action,
  resignationId,
  docs,
  fetchResignations,
}) => {
  const { confirm } = useConfirm();
  const { loggedInUser } = useAuthUser();
  const userRole = loggedInUser?.role;
  const isAdminOrHr = userRole === "1" || userRole === "2";
  const handleDownloadDocument = async (fileName, documentName) => {
    try {
      const response = await downloadResignationDocument(fileName);
      if (response?.status === 200) {
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = documentName || "document";
        a.click();
        window.URL.revokeObjectURL(url);
        toast.success("Document downloaded successfully");
      } else {
        toast.error("Failed to download document. Please try again.");
      }
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        toast.error(
          error.response.data?.message || "Failed to download document"
        );
      } else if (error.request) {
        // Request was made but no response received
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something else happened
        toast.error("An error occurred while downloading the document");
      }
      console.error("Download Document Error:", error);
    }
  };
  const handleDeleteDocument = async (filePath) => {
    try {
      const isConfirmed = await confirm({
        title: "Delete Document",
        content: "Are you sure you want to delete document?",
        confirmText: "Delete",
        cancelText: "Cancel",
      });
      if (isConfirmed) {
        const response = await deleteDocument(resignationId, filePath, docs);
        if (response?.status === 200) {
          toast.success(
            response?.data?.message || "Document deleted successfully"
          );
          fetchResignations();
        } else if (response?.status === 400) {
          toast.warn(
            response?.data?.message || "Bad request. Please try again."
          );
        } else {
          toast.error(response?.data?.message || "Failed to delete document");
        }
      }
    } catch (error) {
      toast.error("An error occurred while deleting the document");
      console.error("Delete Document Error:", error);
    }
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 mb-1">
          <h2>
            {heading}
            {showAddButton && (
              <span className="add float-end">
                <a
                  href="javascipt:void(0)"
                  className="btn btn-success btn-sm"
                  onClick={() => onModalOpen("Upload Document", action)}
                >
                  <span className="material-icons-outlined">add_box</span>
                  &nbsp;
                  <span className="text">Add Document</span>
                </a>
              </span>
            )}
          </h2>
        </div>
      </div>
      <div className="row">
        <TableLayout>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Document</TableHead>
                <TableHead>Uploaded On</TableHead>
                <TableHead>Action</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {documentsData?.length > 0 ? (
                documentsData.map((doc, index) => (
                  <TableRow key={index}>
                    <TableCell>{doc.documentName}</TableCell>
                    <TableCell>
                      {defaultDateFormatter(doc?.uploadedOn)}
                    </TableCell>
                    <TableCell>
                      <Tooltip
                        title="Download Document"
                        placement="right"
                        arrow
                      >
                        <DownloadIcon
                          className="cursor-pointer"
                          onClick={() => {
                            handleDownloadDocument(
                              doc.filePath,
                              doc.documentName
                            );
                          }}
                        />
                      </Tooltip>
                      {(docs !== "hrDocuments" || isAdminOrHr) && (
                        <Tooltip title="Delete Document" placement="top" arrow>
                          <DeleteIcon
                            className="cursor-pointer"
                            onClick={() => {
                              handleDeleteDocument(doc.filePath);
                            }}
                          />
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="3">No documents available</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableLayout>
      </div>
    </div>
  );
};

export default DocumentsTable;
